import i18n from 'i18next';
import type React from 'react';
import { createContext, type ReactNode, useCallback, type FunctionComponent } from 'react';
import { initReactI18next, useTranslation } from 'react-i18next';

export const setupi18n = (files: ITranslationFile[]) => {
  const resources: any = {};

  files.forEach((f) => {
    resources[f.language] = { translation: f.translation };
  });

  i18n.use(initReactI18next).init({
    debug: false,
    lng: 'da',
    resources,
  });
};

export const TranslationContext = createContext<{
  translateString: (key: string, interpolation?: any) => string;
  translateNumber: (num: number) => string;
  translateDate: (date: Date, options?: Intl.DateTimeFormatOptions) => string;
  changeLanguage: (language: string) => void;
  language: string;
}>({
  translateString: () => '',
  translateNumber: () => '',
  translateDate: () => '',
  changeLanguage: () => null,
  language: '',
});

interface ITranslationFile {
  language: string;
  translation: any;
}

interface TranslationProviderProps {
  children: ReactNode;
}

export const TranslationProvider: FunctionComponent<TranslationProviderProps> = ({ children }) => {
  const { t } = useTranslation('');

  const changeLanguage = useCallback((language: string) => {
    i18n.changeLanguage(language);
  }, []);

  const translateNumber = useCallback((num: number) => num.toLocaleString(i18n.language), []);

  const translateDate = useCallback((date: Date, options?: Intl.DateTimeFormatOptions) => {
    return date.toLocaleDateString(i18n.language, options);
  }, []);

  return (
    <TranslationContext.Provider value={{ translateString: t, translateNumber, translateDate, changeLanguage, language: i18n.language }}>
      {children}
    </TranslationContext.Provider>
  );
};
